import { ForgotPassword } from "./forgot-password";
import { Login } from "./login";
import { ResetPassword } from "./reset-password";
import { Unauthorized } from "./unauthorized";

export default {
  ForgotPassword,
  Login,
  ResetPassword,
  Unauthorized,
};
